export default __webpack_public_path__ + "static/media/6.bea9815d.jpg";